import {ScanApiConstant} from "../actionTypes/scan.constant";

const InitialState = {
    polling: false,
    stale: true,
    data: undefined, 
    error: undefined,
    errored_out: false,
}

export const liveViewReducer = ( state = InitialState , action) => {
    switch(action.type){
        case ScanApiConstant.START_LIVE_VIEW:
            return {
                ...state, 
                polling: true,
            }
        case ScanApiConstant.STOP_LIVE_VIEW:
            return {
                ...state, 
                polling: false,
                stale: true
            }
        case ScanApiConstant.UPDATE_LIVE_VIEW:
            return {
                ...state, 
                data: action.data, 
                stale: false
            }
        case ScanApiConstant.FAILED_IN_LIVE_VIEW_UPDATE:
            return {
                ...state, 
                stale: true,
                errorred_out: true, 
                error: action.err
            }
        default :
            return state
    }
}